﻿//import kendo from '@progress/kendo-ui';
import { _address } from './i247.Address.js';
import { _data } from './Tyres/data.tyre.js';

class Mapping {
    constructor () {
        this.green = '#00C800';
        this.blue = '#4472c4';
        this.selectedDepotId = null;
        this.map = null;
        this.infobox = null;
		this.depots = [];
		this.debug = false;
		this.manufacturerId = 0;
		this.serviceId = 0;
		this.level = 1;
		this.tier = 1;
		this.postcode = null;
		this.serviceType = null;
		this.customerId = null;
    }

    ResetState () {
        $('#grid').html('');
        $('#map').html('');
        this.selectedDepotId = null;
        this.map = null;
        this.infobox = null;
        this.depots = [];
        this.manufacturerId = 0;
		this.serviceId = 0;
		this.postcode = null;
    }

	SetManufacturerId(manufacturerId) {
		this.manufacturerId = manufacturerId;
	}

	SetServiceType(serviceType) {
		this.serviceType = serviceType;
	}

	SetCustomerId(customerId) {
		this.customerId = customerId;
	}

	GetPostcodeCoordinates() {
		kendo.ui.progress($("body"), true);
        let _this = this;
        if (this.postcode != $('#jobPostcode').val()) {
            this.ResetState();
            this.postcode = $('#jobPostcode').val();
            var coordinatesRequest = _address.GetCoordinates(this.postcode, $('input[name=__RequestVerificationToken]').val(), '');
            $.when(coordinatesRequest).then(function (coordinates) {
                _this.coordinates = coordinates;
                _this.RefreshMap(coordinates);
                var depotsRequest = _this.GetDepotList(coordinates.latitude, coordinates.longitude);
                $.when(depotsRequest).then(function (response) {
                    _this.depots = response;
                    var clusterDepots = false;
                    _this.PlotDepots(clusterDepots);
                    _this.RefreshDepotList();
                    kendo.ui.progress($("body"), false);
                });
            });
        }
        else {
            kendo.ui.progress($("body"), false);
        }
    }

    RefreshMap (coords) {
        let _this = this;
        if (!coords) coords = _this.coordinates;
        // Create map
        var jobLocation = new Microsoft.Maps.Location(coords.latitude, coords.longitude);
        _this.map = new Microsoft.Maps.Map(document.getElementById('map'), {
            center: jobLocation,
            zoom: 12
        });
        // Create an infobox for depot information. This is hidden by default, and
        // populated and displayed when a pushpin is selected
        _this.infobox = new Microsoft.Maps.Infobox(_this.map.getCenter(), {
            visible: false,
            autoAlignment: true
        });
        _this.infobox.setMap(_this.map);

        // Draw proximity circles
        Microsoft.Maps.loadModule('Microsoft.Maps.SpatialMath', function () {
            // Inner circle
            var greenFill = new Microsoft.Maps.Color(0.1, 0, 200, 0);
            var greenStroke = new Microsoft.Maps.Color(1, 0, 200, 0);
            _this.DrawMapCircle(jobLocation, 5, greenFill, greenStroke);

            // Outer circle
            var blueFill = new Microsoft.Maps.Color(0, 0, 0, 200);
            var blueStroke = new Microsoft.Maps.Color(1, 0, 0, 200);
            _this.DrawMapCircle(jobLocation, 10, blueFill, blueStroke);

            // Add a pushpin at the user's location.
            var pin = new Microsoft.Maps.Pushpin(jobLocation);
            _this.map.entities.push(pin);
        });
    }

	GetDepotList(latitude, longitude) {
        var result = $.Deferred();
        var url = '';

		if (this.serviceType === 'S') {
			url = '/servicebooking/depots';
		} else if (this.serviceType === 'T') {
            url = '/supplier/depots';
		}

        $.ajax({
            url: url,
            type: 'POST',
            data: {
                customerId: this.customerId === '5130292' ? '5479221' : this.customerId,
                latitude: this.coordinates.latitude,
                longitude: this.coordinates.longitude
            },
            success (data) {
                result.resolve(data);
            },
            error (xhr, ajaxOptions, thrownError) {
            },
            complete (data) {
            }
        });

        return result.promise();
    }

    DrawMapCircle (location, radius, fillColour, strokeColour) {
        var path = Microsoft.Maps.SpatialMath.getRegularPolygon(location, radius, 360, Microsoft.Maps.SpatialMath.DistanceUnits.Miles);
        var poly = new Microsoft.Maps.Polygon(path, {
            fillColor: fillColour,
            strokeColor: strokeColour,
            strokeThickness: 1,
            strokeDashArray: [1, 2]
        });
        this.map.entities.push(poly);
    }

	RefreshDepotList() {
        let _this = this;
		if ($('#grid').parents('.section').prop('id') === 'jobLocationSection'
		 || $('#grid').parents('.section').prop('id') === 'garageSelection') {
        }

        let selectedDepotId = _data.selectedDepot ?  _data.selectedDepot.id :  _this.GetSelectedDepotId();

        $('#grid').html('');
        $('#grid').kendoGrid({
            dataSource: _this.depots,
            resizable: true,
            selectable: true,
            scrollable: true,
            columns: [{
                field: 'id',
                title: 'ID',
                hidden: true
            }, {
                field: 'id',
                title: ' ',
                template: '<div class="text-center"><div class="custom-control custom-radio"><input class="custom-control-input depot-radio-btn" type="radio" name="depot-list" required id="#: id#" data-depot-id="#: id#"> <label class="custom-control-label" for="#: id#"></label></div></div>',
                width: '30px',
            }, {
                field: 'name',
                title: 'Depot name',
                template: kendo.template($('#depot-address-template').html()),
                media: "(min-width: 450px)"
            }, {
                field: 'distanceInMiles',
                title: 'Distance',
                template: "<div style='text-align:left'>#=Number(distanceInMiles).toFixed(2)# miles</div>",
                media: "(min-width: 450px)"
            },
            {
                title: "Garage location",
                template: kendo.template($("#depot-address-template-mobile").html()),
                media: "(max-width: 450px)"
            }
            ],
            change: function () {
                let row = this.select();
                let $input = $(row).find('.depot-radio-btn');
                $input[0].checked = true;
                _this.SelectDepot($input.data('depotId'));
                $('.nextButtonSlide').show();
            }
        }).kendoValidator({
            rules: {
                depotMissing: function (input) {
                    if (input.is("[type=radio]") && input.attr("required")) {
                        return $("#grid").find("[name=depot-list]").is(":checked");
                    }
                	return true;
                }
            },
            messages: {
                depotMissing: 'Please select a depot'
            }
        }).data('kendoValidator');
    }

    PlotDepots (clusterDepots) {
        let _this = this;
        // Create an array of depot pushpins
        var pushpins = [];
        _this.depots.forEach(function (depot) {
            // Define pushpin
            var location = new Microsoft.Maps.Location(depot.latitude, depot.longitude);
            var pushpin = new Microsoft.Maps.Pushpin(location, {
                color: _this.blue,
                enableHoverStyle: true
            });

                // Create metadata linking pushpin to depot
            if (!pushpin.metadata) {
                pushpin.metadata = {};
            }
            $.extend(pushpin.metadata, {
                title: depot.name,
                depotId: depot.id,
                address: depot.address.split(',').join('<br/>'),
                selected: false
            });

            // Attach handler for selecting depot
            Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) {
                _this.SelectDepot(args.target.metadata.depotId);
            });

            pushpins.push(pushpin);
        });

        // Display depots
        if (clusterDepots) {
            Microsoft.Maps.loadModule('Microsoft.Maps.Clustering', function () {
                var clusterLayer = new Microsoft.Maps.ClusterLayer(pushpins);
                _this.map.layers.insert(clusterLayer);
            });
        } else {
            _this.map.entities.push(pushpins);
        }
    }

    SelectDepot(depotId) {
        let _this = this;
        // De-select active depot
        var pushpin = null;
        var depotListCircle = null;
        _this.RefreshMap();
        _this.PlotDepots(false);

        if (_this.selectedDepotId) {
            // Map
            pushpin = _this.GetPushpinByDepotId(_this.selectedDepotId);
            pushpin.setOptions({ color: _this.blue });
            _this.infobox.setOptions({ visible: false });
        }
        _this.selectedDepotId = depotId;
        pushpin = _this.GetPushpinByDepotId(_this.selectedDepotId);
        pushpin.setOptions({ color: _this.green });

        // Display information about depot
        _this.infobox.setOptions({
            location: pushpin.getLocation(),
            title: pushpin.metadata.title,
            description: pushpin.metadata.address,
            maxHeight: 256,
            visible: true
        });

        _data.selectedDepot = _this.depots.filter(depot => depot.id === depotId)[0];
    }

    GetPushpinByDepotId (depotId) {
        let _this = this;
        var pushpin = null;
        var mapEntities = _this.map.entities;
        var entityCount = mapEntities.getLength();
        for (var i = 0; i < entityCount; i++) {
            var entity = mapEntities.get(i);
            if (entity instanceof Microsoft.Maps.Pushpin) {
                var metadata = entity.metadata;
                if (metadata && metadata.depotId === depotId) {
                    pushpin = entity;
                    break;
                }
            }
        };
        return pushpin;
    }

	GetMap() {
		let _this = this;
        return this.map;
    }

	GetDepots() {
		let _this = this;
        return this.depots;
    }

	GetSelectedDepotId() {
		let _this = this;
        return this.selectedDepotId;
	}
}

export let _mapping = new Mapping();
